module.exports = __webpack_public_path__ + "static/img/anger1.b690bcc2.png";